import React from 'react';
import './Cali.css'; 

const Popayan = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKPP.pdf" target="_blank" rel="noreferrer">Aeropuerto Guillermo León Valencia</a></h1>
    </div>
    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 08</th>                      
          </tr>    
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/CLO4B.pdf" target="_blank" rel="noreferrer">CLO1J</a></th>
          </tr>   
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/CLO1K.pdf" target="_blank" rel="noreferrer">CLO1K</a></th>
          </tr>   
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/CLO1K.pdf" target="_blank" rel="noreferrer">GAVA1D</a></th>
          </tr> 
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/CLO1K.pdf" target="_blank" rel="noreferrer">MER1H</a></th>
          </tr> 
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/CLO1K.pdf" target="_blank" rel="noreferrer">KUDG1G</a></th>
          </tr> 
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 26</th>                      
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/CLO4B.pdf" target="_blank" rel="noreferrer">CLO4B</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/CLO1L.pdf" target="_blank" rel="noreferrer">CLO1L</a></th>
          </tr> 
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/CLO1L.pdf" target="_blank" rel="noreferrer">GIBT1J</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/CLO1L.pdf" target="_blank" rel="noreferrer">MER1G</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/CLO1L.pdf" target="_blank" rel="noreferrer">KUDG1F</a></th>
          </tr>
          
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 08</th>                      
          </tr>   
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/GIBT1K.pdf" target="_blank" rel="noreferrer">GIBT1K</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/GIBT1K.pdf" target="_blank" rel="noreferrer">MER1J</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/GIBT1K.pdf" target="_blank" rel="noreferrer">KUDG1H</a></th>
          </tr>
          
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/GIBT1K.pdf" target="_blank" rel="noreferrer">KONK1C</a></th>
          </tr>

          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 26</th>                      
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKPP/GIBT1K.pdf" target="_blank" rel="noreferrer">KONK1B</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 08</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPP/VORY08.pdf" target="_blank" rel="noreferrer">VOR Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPP/VORZ08.pdf" target="_blank" rel="noreferrer">VOR Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPP/RNPZ08.pdf" target="_blank" rel="noreferrer">RNP Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPP/RNPYAR08.pdf" target="_blank" rel="noreferrer">RNP Y AR</a></th>
          </tr>

          
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 26</th>                      
          </tr> 
         <tr>
            <th className='Procedimientos'><a href="/regionales/SKPP/RNPRVFP26.pdf" target="_blank" rel="noreferrer">RNP RVFP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Popayan;